import { http } from '@/http'

export default {
  getSettlements(companyId) {
    return http.get('/severances', { params: { companyId } })
  },
  getEligibleContracts(companyId) {
    return http.get('/severances/eligible-contracts', { params: { companyId } })
  },
  getSettlementDetail(id) {
    return http.get(`/severances/${id}`)
  },
  calculate(data) {
    return http.post('/severances/calculate', data)
  },
  confirm(id) {
    return http.put(`/severances/${id}/confirm`)
  },
  pay(id, data) {
    return http.put(`/severances/${id}/pay`, data)
  },
  annul(id, reason) {
    return http.put(`/severances/${id}/annul`, { reason })
  },
  recalculate(id) {
    return http.post(`/severances/${id}/recalculate`)
  },
  discard(id) {
    return http.delete(`/severances/${id}`)
  },
}
